import React, { Component } from "react"

export default class TDSpod extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">thedogsense</p>
            <p className="portdesctext">Co-host, co-founder, research, editing & web design.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href="https://www.thedogsense.com/" target="_blank" rel="noopener noreferrer"><p className="linktext">Website</p></a>
        </div>
      </div>
  )
}
}

